<ion-header>
  <app-header [isHome]="isHome"
              [logo]="merchant.merchantLogo"
              [sourceBanner]="merchant.merchantBanner"
              [isCollapse]="!isScrollPositionTop"
              [merchantName]="merchant?.merchantName"
              [merchantHeaderTitle]="merchant?.merchantHeaderTitle"
              [merchantHeaderText]="merchant?.merchantHeaderText"
              pageName="merchant">
    <div class="restaurants__wrapper">
      <button type="button"
              class="restaurants__top-button"
              [class.restaurants__top-button--is-colapse]="!isScrollPositionTop">
        Locations
      </button>
    </div>
  </app-header>
</ion-header>

<ion-content [scrollEvents]="true">
  <div class="container">
    <div class="container__content restaurants">
      <div class="restaurants__restaurant-wrapper"
           *ngFor="let restaurant of restaurantStore.sortedRestaurants$ | async; let index = index; let last = last">
        <ion-card class="restaurants__restaurant" (click)="goToRestaurantPage(restaurant)">
          <img
            *ngIf="!restaurant.isAcceptingOrders || !restaurant.isMobileEnabled"
            [src]="restaurantAllowScheduledOrders(restaurant) ? restaurantPreordersSign : restaurantClosedSign"
            class="restaurants__restaurant-closed-sign"
            [hidden]="isHideSigns(restaurant)"
            alt="restaurant closed sign"/>
          <img
            [src]="getLocationImage(restaurant)"
            class="restaurants__restaurant-image"
            alt="restaurant logo image"/>
          <ion-card-header class="restaurants__restaurant-header">
            <!--        <ion-card-subtitle>Card Subtitle</ion-card-subtitle>-->
            <ion-card-title class="restaurants__restaurant-title">{{restaurant.name}}
<!--              TODO: uncomment a share icon latter-->
<!--              <img class="restaurants__restaurant-share"-->
<!--                   [src]="shareImageUrl"-->
<!--                   alt="share icon"/>-->
            </ion-card-title>
          </ion-card-header>

          <ion-card-content class="restaurants__restaurant-content">
            <div>
              <ion-label>
                <span class="restaurants__restaurant-detail-title">Address:&#160;</span>
                <span class="restaurants__restaurant-detail-info">{{restaurant.address.addressLine}}
                  <img class="restaurants__restaurant-maps"
                       [src]="googleMapsImageUrl"
                       alt="g-maps icon"
                       (click)="openLocationInMaps(restaurant.address)"/>
              </span>
              </ion-label>
            </div>
            <div *ngIf="restaurant.contactPhoneNumber" (click)="$event.stopPropagation()">
              <ion-label>
                <span class="restaurants__restaurant-detail-title">Phone:&#160;</span>
                <span class="restaurants__restaurant-detail-info">
                  <a class="restaurants__restaurant-detail-phone-link" href="tel:{{formatPhoneNumber(restaurant.contactPhoneNumber, 'international')}}">{{formatPhoneNumber(restaurant.contactPhoneNumber, 'national')}}</a>
                </span>
              </ion-label>
            </div>
            <div *ngIf="restaurant.isShowHours">
              <ion-label>
                <span class="restaurants__restaurant-detail-title">Hours:&#160;</span>
                <span class="restaurants__restaurant-address">
                <span *ngIf="!restaurant.isMobileEnabled">Closed</span>
                <span *ngIf="!restaurant.showHoursInfo && restaurant.isMobileEnabled" (click)="showHoursInfo(restaurant)">{{getDay(blackoutedDays[restaurant.locationId], 0)}}
                  <img class="restaurants__restaurant-triangle" [src]="arrowDown" alt="arrow-down icon"/>
                </span>
                <ul class="restaurants__restaurant-hours" *ngIf="restaurant.showHoursInfo && restaurant.isMobileEnabled" (click)="showHoursInfo(restaurant)">
                  <li *ngFor="let day of getRestaurantHours(restaurant); let i = index" [ngStyle]="{'font-weight': 'normal'}">{{day}}
                    <img *ngIf="i === 0" class="restaurants__restaurant-triangle" [src]="arrowUp" alt="arrow-up icon" (click)="showHoursInfo(restaurant)"/>
                  </li>
                </ul>
              </span>
              </ion-label>
            </div>
            <div class="restaurants__restaurant-no-hours" *ngIf="!restaurant.isShowHours" ></div>
          </ion-card-content>
        </ion-card>
        <!--  ----------This part for mobile location----------- -->
<!--   <ion-card class="restaurants__restaurant"-->
<!--             (click)="goToRestaurantPage(restaurant)">-->
<!--     <img-->
<!--       *ngIf="!restaurant.isAcceptingOrders"-->
<!--       [src]="restaurantClosedSign"-->
<!--       class="restaurants__restaurant-closed-sign"-->
<!--       alt="restaurant closed sign"/>-->
<!--     <img-->
<!--       [src]="restaurant.locationImageUrl || defaultImageUrl"-->
<!--       class="restaurants__restaurant-image"-->
<!--       alt="restaurant logo image"/>-->
<!--     <div class="restaurants__restaurant-mobile-chip">Mobile Location</div>-->
<!--     <ion-card-header class="restaurants__restaurant-header">-->
<!--       &lt;!&ndash;        <ion-card-subtitle>Card Subtitle</ion-card-subtitle>&ndash;&gt;-->
<!--            <ion-card-title class="restaurants__restaurant-title">{{restaurant.name}}-->
<!--              <img class="restaurants__restaurant-share"-->
<!--                   [src]="shareImageUrl"-->
<!--                   alt="share icon"/>-->
<!--            </ion-card-title>-->
<!--          </ion-card-header>-->
<!--          <ion-card-content class="restaurants__restaurant-content">-->
<!--            <div>-->
<!--              <ion-label>-->
<!--                <span class="restaurants__restaurant-detail-title">Today's Location:&#160;</span>-->
<!--                <span class="restaurants__restaurant-detail-info">{{restaurant.address.addressLine}}-->
<!--                  <img class="restaurants__restaurant-maps"-->
<!--                       [src]="googleMapsImageUrl"-->
<!--                       alt="g-maps icon"-->
<!--                       (click)="openLocationInMaps(restaurant.address)"/>-->
<!--              </span>-->
<!--              </ion-label>-->
<!--            </div>-->
<!--            <div>-->
<!--              <ion-label>-->
<!--                <span class="restaurants__restaurant-detail-title">Phone:&#160;</span>-->
<!--                <span class="restaurants__restaurant-detail-info">{{restaurant.contactPhoneNumber}}</span>-->
<!--              </ion-label>-->
<!--            </div>-->
<!--            <div>-->
<!--              <ion-label>-->
<!--                <span class="restaurants__restaurant-detail-title">Schedule:&#160;</span>-->
<!--                <span class="restaurants__restaurant-address">-->
<!--                <span *ngIf="!restaurant.showHoursInfo">{{getDay(restaurant.hoursOfOperation, 7)}}-->
<!--                  <img class="restaurants__restaurant-triangle" [src]="arrowDown" alt="arrow-down icon"-->
<!--                       (click)="showHoursInfo(restaurant)"/>-->
<!--              </span>-->
<!--                <ul class="restaurants__restaurant-hours" *ngIf="restaurant.showHoursInfo">-->
<!--                  <li *ngFor="let day of getRestaurantHours(restaurant.hoursOfOperation); let i = index"-->
<!--                      [ngStyle]="{'font-weight': i === 0 ? 'bold' : 'normal'}">{{day}}-->
<!--                    <img *ngIf="i === 0" class="restaurants__restaurant-triangle" [src]="arrowUp" alt="arrow-up icon"-->
<!--                         (click)="showHoursInfo(restaurant)"/>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </span>-->
<!--              </ion-label>-->
<!--            </div>-->
<!--          </ion-card-content>-->
<!--        </ion-card>-->
      </div>
    </div>
    <!--  <ng-container *ngIf="isEmptyList">
        <div class="restaurant__empty-list">This merchant cannot be found</div>

      </ng-container>-->
  </div>
</ion-content>


